import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, AlertController } from 'ionic-angular';

import { ConsumerPointsHandlerProvider } from '../../providers/consumer-points-handler';
import { ConsumerRewardHandlerProvider } from '../../providers/consumer-reward-handler';

@Component({
  selector: 'page-consumer-reward-buy',
  templateUrl: 'consumer-reward-buy.html',
})
export class ConsumerRewardBuyPage {
	reward: any;
	points: any;

	canBuyReward: any = true;

	constructor(
		public navCtrl: NavController, 
		public navParams: NavParams,
		public loadingCtrl: LoadingController,
		public alertCtrl: AlertController,		
		private consumerPointsHandlerProvider: ConsumerPointsHandlerProvider, 
		private consumerRewardHandlerProvider: ConsumerRewardHandlerProvider, 
	) {
		this.reward = navParams.get('reward');		

		this.points = consumerPointsHandlerProvider.availablePoints;
	}

  ionViewDidLoad() {
    console.log('ionViewDidLoad ConsumerRewardBuyPage');
  }

  buy(){
	var loader = this.loadingCtrl.create({
		content: "Cargando...",
		showBackdrop: true
	});

	loader.present();	

	// this.consumerRewardHandlerProvider.buy(this.reward.Id, (response)=>{
	// 	var msg = "";
	// 	if(response.Success==true){
	// 		msg = "You bought this reward!"
	// 		this.consumerPointsHandlerProvider.getPointsByUser(null);
	// 	}else{
	// 		msg = response.Message;
	// 	}

	// 	loader.dismiss()

	//     let alert = this.alertCtrl.create({
	//       title: 'Messasge',
	//       message: msg,
	//       buttons: [
	//         {
	//           text: 'Ok'
	//         }
	//       ]
	//     });

 //    	alert.present();
	// })	
  }
}



// WEBPACK FOOTER //
// ./src/pages/consumer-reward-buy/consumer-reward-buy.ts